import HelpButton from "../../HelpButton";

export default function InventoryHelp() {
  return (
    <HelpButton>
      <div className="help-page">
        <p>
          Puedes usar este módulo para registrar y gestionar el inventario de tu
          grupo y llevar un mejor control de los materiales a lo largo del
          tiempo.
        </p>
        <p>
          Para registrar un nuevo item, haz click en el botón &ldquo;Nuevo
          item&ldquo; y completa el formulario.
        </p>
      </div>
    </HelpButton>
  );
}
